import { Button, Card, ErrorBoundary, Form, Input, Popconfirm, When } from '@components'
import { showFormErrors } from '@helpers'
import { useEntityListItemAPI, useHistory, useParams, useTranslation } from '@hooks'
import { TStore } from '@typings'
import { formFieldRules, formLayout, formButtonLayout } from './EditStore.formOptions'
import * as React from 'react'

const EditStoreScreen: React.FC<TProps> = () => {
	// Main screen data.
	const { t } = useTranslation()
	const history = useHistory()
	const params = useParams<TParams>()
	const id = Number(params?.id)

	const Store = useEntityListItemAPI<TStore>('/lists/stores', id, {
		onCreate: history.goBack,
		onUpdate: history.goBack,
		onRemove: history.goBack,
	})

	return (
		<ErrorBoundary>
			<Card
				loading={(id && Store.fetching) || Store.creating || Store.updating}
				title={t('Store')}
				extra={
					<Popconfirm title="Are you sure?" onConfirm={Store.remove} okText={t('Yes')} cancelText={t('No')}>
						<Button disabled={!Store?.data?.id} loading={Store.removing} type="danger">
							{t('Remove store')}
						</Button>
					</Popconfirm>
				}
			>
				<When condition={Store.fetched || !id}>
					<Form
						onFinish={id ? Store.update : Store.create}
						onFinishFailed={showFormErrors}
						initialValues={Store.data}
						{...formLayout}
					>
						<Form.Item label={t('Title')} name="title" rules={formFieldRules.title}>
							<Input required disabled={Store.updating} />
						</Form.Item>
						<Form.Item wrapperCol={formButtonLayout}>
							<Button type="primary" htmlType="submit" loading={Store.creating || Store.updating}>
								{!!Store?.data?.id ? t('Save') : t('Create')}
							</Button>
							<Button htmlType="button" onClick={history.goBack}>
								{t('Cancel')}
							</Button>
						</Form.Item>
					</Form>
				</When>
			</Card>
		</ErrorBoundary>
	)
}

type TParams = { id?: string }
type TProps = {
	/** */
}

export default EditStoreScreen
